import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/app/quizzes/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <div className="p-4">Quizzes</div>
}
